<template>
    <div ref="chartcontainer"
         class="border border-grey-200 rounded-2xl mobile:p-2 grid grid-cols-[16rem_auto] mobile:flex mobile:flex-col-reverse divide-x divide-grey-200 mobile:divide-none">
        <div class="py-6 px-5 space-y-4 " v-if="kerncijfersStore.chartData">
            <template v-for="kerncijfer in kerncijfersStore.chartData" :for="kerncijfer.label">
                <label v-if="!kerncijfer.hasNoValues" class="mb-0 flex items-center rounded hover:bg-grey-100 cursor-pointer select-none gap-x-2 px-1 text-sm" >
                    <div :class="ColorMap[kerncijfer.color].background" class="size-2.5 rounded-full"></div>
                    <input :id="kerncijfer.label" type="checkbox" class="!mt-0 !hidden !appearance-auto peer" v-model="kerncijfer.isActive" :class="ColorMap[kerncijfer.color].accent"/>
                    <span  class="font-medium text-grey-400 peer-checked:text-black py-1.5 px-1 ">
                        {{ kerncijfer.label }}
                    </span>
    
                    <span class="ml-auto !my-0 peer-checked:block hidden">
                      <i class="far fa-eye text-grey-600"></i>
                    </span>
                    <span class="ml-auto !my-0 peer-checked:hidden block">
                      <i class="far fa-eye-slash text-grey-400"></i>
                    </span>
                </label>
            </template>
        </div>
        <div class="py-6 pl-6 mobile:pl-0 mobile:py-3">
            <svg :width="kerncijfersStore.containerWidth" :height="kerncijfersStore.containerHeight+kerncijfersStore.margin" class="w-full">
                <chart-year v-for="(year, index) in years" :label="year" :key="year" :index="index" :years="kerncijfersStore.years"></chart-year>
                <g :width="kerncijfersStore.chartWidth" :height="kerncijfersStore.chartHeight" :transform="'translate('+kerncijfersStore.yAxisWidth+','+kerncijfersStore.margin+')'">
                    <g id="yAxis">
                        <chart-y-axis-separator v-for="(value, idx) in kerncijfersStore.yAxisValues"
                                                :value="value"
                                                :y="kerncijfersStore.valueToYPos(value)"
                                                :index="idx"
                                                :key="'separator-' + idx">
                        </chart-y-axis-separator>
                    </g>
                    <chart-category v-for="(kerncijfer, index) in kerncijfersStore.chartData"
                                    v-bind="kerncijfer"
                                    type="segment"
                                    :years="years"
                                    :key="'segment-' + index">
                    </chart-category>
                    <chart-category v-for="(kerncijfer, index) in kerncijfersStore.chartData"
                                    v-bind="kerncijfer"
                                    type="node"
                                    :years="years"
                                    :key="'node-' + index">
                    </chart-category>
                    <node-info v-if="kerncijfersStore.hoveredElement" :hovered-element="kerncijfersStore.hoveredElement"></node-info>
                </g>
            </svg>
        </div>
    </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import ChartCategory from './chart-category.vue';
import ChartYear from './chart-year.vue';
import ChartYAxisSeparator from './chart-y-axis-separator.vue';
import NodeInfo from './node-info.vue';
import { ColorMap} from "./types";
import {useKerncijfersStore} from "./store";


Math.log10 = function (x: number): number {
    if (!(x > 0 && x < 1 / 0)) {
        return Math.log(x) * Math.LOG10E;
    }
    const n = Math.round(Math.log(Math.min(Math.max(x, 10 / Number.MAX_VALUE), Number.MAX_VALUE / 10)) * Math.LOG10E);
    return n + Math.log(x / Math.pow(10, n)) * Math.LOG10E;
}

export default defineComponent({
    name: "kerncijfers-chart",
    components: {
        ChartCategory,
        NodeInfo,
        ChartYear,
        ChartYAxisSeparator
    },
    data() {
        return {
            kerncijfersStore: useKerncijfersStore(),
            ColorMap
        }
    },
    computed:{
        years(): string[] {
            return this.kerncijfersStore.years;
        }  
    },
    mounted(): void {
        const chartContainer = this.$refs.chartcontainer as HTMLDivElement;
        const padding = this.kerncijfersStore.isMobile ? 10 : 30;
        const labelsWidth = this.kerncijfersStore.isMobile ? 0 : this.kerncijfersStore.labelsWidth;
        this.kerncijfersStore.containerWidth = chartContainer.clientWidth - padding - labelsWidth;

        this.kerncijfersStore.createChartData();
    }
});
</script>